import React, { useEffect, useState } from "react";
import {
  Percent,
  ShieldCheck,
  MapPin,
  PhoneCall,
  MessageCircle,
} from "lucide-react";

export default function TopBar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`
        fixed
        left-0
        top-0
        z-[1100]
        w-full
        bg-[#062F4F]
        text-white
        transition-transform
        duration-300
        ease-out

        ${isScrolled
          ? "-translate-y-full"
          : "translate-y-0"
        }
      `}
    >
      <div
        className="
          mx-auto
          flex
          min-h-[36px]
          w-full
          max-w-screen-2xl
          items-center
          justify-between
          px-4
          lg:px-8
        "
      >
        {/* Desktop Left */}

        <div className="hidden items-center gap-6 text-[11px] sm:flex">

          <div className="flex items-center gap-2">
            <Percent
              size={14}
              strokeWidth={2.2}
              className="text-[#F7B928]"
            />

            <span className="text-white/85">
              Best Hotel Deals
            </span>

            <span className="font-semibold text-[#F7B928]">
              Save up to 60%
            </span>
          </div>

          <span className="h-4 w-px bg-white/20" />

          <div className="flex items-center gap-2 text-white/85">
            <ShieldCheck
              size={14}
              strokeWidth={2}
              className="text-[#F7B928]"
            />

            <span>Verified Hotels</span>
          </div>

          <span className="h-4 w-px bg-white/20" />

          <div className="flex items-center gap-2 text-white/85">
            <MapPin
              size={14}
              strokeWidth={2}
              className="text-[#F7B928]"
            />

            <span>Exclusive Local Deals</span>
          </div>
        </div>

        {/* Desktop Right */}

        <div className="hidden items-center gap-5 text-[11px] lg:flex">

          <a
            href="tel:+97144473839"
            className="
              group
              flex
              items-center
              gap-2
              text-white/85
              transition-colors
              duration-200
              hover:text-[#F7B928]
            "
          >
            <PhoneCall
              size={14}
              strokeWidth={2}
              className="
                text-[#F7B928]
                transition-transform
                duration-200
                group-hover:scale-110
              "
            />

            <span>+971 4 447 3839</span>
          </a>

          <span className="h-4 w-px bg-white/20" />

          <a
            href="https://wa.me/971502477593"
            target="_blank"
            rel="noopener noreferrer"
            className="
              group
              flex
              items-center
              gap-2
              text-white/85
              transition-colors
              duration-200
              hover:text-[#F7B928]
            "
          >
            <MessageCircle
              size={14}
              strokeWidth={2}
              className="
                text-[#F7B928]
                transition-transform
                duration-200
                group-hover:scale-110
              "
            />

            <span>WhatsApp Us</span>
          </a>
        </div>

        {/* Mobile */}

        <div className="flex w-full overflow-hidden sm:hidden">
          <div
            className="
              flex
              min-w-max
              animate-[marquee_20s_linear_infinite]
              items-center
              gap-8
              whitespace-nowrap
              text-[11px]
            "
          >
            <span className="flex items-center gap-2">
              <Percent
                size={14}
                className="text-[#F7B928]"
              />

              <span>
                Best Hotel Deals:
                <strong className="ml-1 text-[#F7B928]">
                  Save up to 60%
                </strong>
              </span>
            </span>

            <span className="flex items-center gap-2">
              <ShieldCheck
                size={14}
                className="text-[#F7B928]"
              />

              Verified Hotels
            </span>

            <span className="flex items-center gap-2">
              <MapPin
                size={14}
                className="text-[#F7B928]"
              />

              Exclusive Dubai Deals
            </span>

            <span className="flex items-center gap-2">
              <MessageCircle
                size={14}
                className="text-[#F7B928]"
              />

              WhatsApp Us
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}